module.exports = __webpack_public_path__ + "img/Joshua Hinckley.fa20463c.jpg";